module.exports = __webpack_public_path__ + "static/media/up-arrow-green.87480532.svg";